var Enum = Enum || { MEEDY : {}};

Enum.MEEDY.OFFER_TYPE = {
    SPECIALIZATION: 'SPECIALIZATION',
    EXAMINATION: 'EXAMINATION',
    INTERVENTION: 'INTERVENTION',
    ONLINE_CONSULTATION: 'ONLINE_CONSULTATION',
    TRIP: 'TRIP',
    NIGHT_TRIP: 'NIGHT_TRIP',
    ADDITIONAL_PROCEDURE: 'ADDITIONAL_PROCEDURE',
    REHABILITATION: 'REHABILITATION',
    HOME_MEDICAL_CARE: 'HOME_MEDICAL_CARE'
};

Object.freeze(Enum.MEEDY.OFFER_TYPE);